import styled from 'styled-components';

const Button = styled.div`
  a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    background-color: ${({ color }) => {
      return color;
    }};
    text-decoration: none;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-color: ${({ border }) => {
      return border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    padding: 10px;
    margin-bottom: 10px;
    transition: padding-left 200ms ease-in-out;

    &:hover {
      padding-left: 30px;
    }

    img {
      margin-right: 20px;
      height: 20px;
    }
    span {
      ${({ active }) => {
        if (active) {
          return { 'text-shadow': '0px 0px 12px white' };
        }
      }};
    }
  }
`;
export default Button;
